<div class="filter-section__body">
    <div>
        <input id="{{ option.key }}" type="checkbox" [(ngModel)]="option.checked" (change)="onChecked()" />
        <label for="{{ option.key }}">{{ option.value }}</label>
    </div>
</div>
